import { useLocation } from "react-router-dom";
import StockRecordPage from "./StockRecordPage";

const SaleRecords = () => {
    const { pathname } = useLocation();
    return (
        <StockRecordPage
            type="sale"
            title="Sale Records"
            navId={pathname}
            metaKey="saleRecords"
            apiBase="/api/v1/sale-records"
            breadcrumbParent={pathname.startsWith("/admin") ? "Admin" : "Dashboard"}
        />
    );
};

export default SaleRecords;
